import { Component, Model, Prop, Vue } from 'nuxt-property-decorator';

@Component<Input>({
  data() {
    return {
      value: this.inputValue
    };
  }
})
export default class Input extends Vue {
  @Model('input', { type: String })
  inputValue!: string;

  @Prop({ type: String, default: 'text' })
  type!: string;

  @Prop()
  label!: string;

  @Prop({type: Boolean, default: false})
  noBorder!: Boolean;

  @Prop({type: Boolean, default: false})
  noBg!: Boolean;

  @Prop({type: Object, default: null})
  placeHolderClass!: Object;

  @Prop({ type: String, default: '' })
  placeholder!: string;

  // State
  @Prop({ type: Boolean, default: false })
  readonly!: boolean;

  @Prop({ type: Boolean, default: false })
  disabled!: boolean;

  @Prop({ type: Boolean, default: false })
  small!: boolean;

  @Prop({ type: Boolean, default: false })
  error!: boolean;

  @Prop({ type: Number, default: 0 })
  size!: number;

  @Prop({ type: Boolean, default: false })
  autofocus!: boolean;

  @Prop({type: Boolean, default: false})
  required!: Boolean;

  get hasDescription(): boolean {
    return !!this.$slots.default;
  }

  updateInput(value: string): void {
    this.$emit('input', value);
  }
}
